import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';

@Component({
  selector: 'app-add-post-caps',
  templateUrl: './add-post-caps.component.html',
  styleUrls: ['./add-post-caps.component.scss']
})
export class AddPostCapsComponent implements OnInit {

  @Output() step2Editer = new EventEmitter();

  postCapsAvailable: boolean;

  constructor(
    private dataForMenu: DataForDisplayingMenuItemsService,
    private railingGenerationService: RailingGenerationService
  ) { }

  togglePostCaps(value) {
    this.railingGenerationService.setPostCaps(value);
  }

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }

  ngOnInit() {
    this.dataForMenu.topRail.subscribe(topRail => {
      switch (topRail) {
        case '100s': {
          this.postCapsAvailable = true;
          break;
        }
        case '150s': {
          this.postCapsAvailable = true;
          break;
        }
        case 'Wood 2x4': {
          this.postCapsAvailable = true;
          break;
        }
        default: {
          this.postCapsAvailable = false;
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/add-post-caps/add-post-caps.component.ts